import { EXPORT_PAYMENTS_ZIP } from "..";
import { apiInstance } from "../config/apiInstance";
import { AxiosResponse } from "axios";

export type ExportPaymentsRow = {
  consecutive: string;
  conceptCode: string;
  employerIdNumber: string;
  totalValue: number;
  operatingIndicator: string;
  costCenterCode: string;
  budgetCertificate: string;
  budgetRegistration: string;
  materialCode: string;
};

export type PostExportPaymentsRequest = {
  electronicDocumentIds: number[];
  rows: ExportPaymentsRow[];
};

export const postExportPaymentsZip = async (
  data: PostExportPaymentsRequest,
): Promise<AxiosResponse<Blob>> => {
  const response = await apiInstance.post<Blob>(EXPORT_PAYMENTS_ZIP, data, {
    responseType: "blob",
    timeout: 0,
    headers: {
      "X-Timezone-Id": "America/Bogota",
      "Accept-Language": "es-CO",
    },
  });

  return response;
};
